/**
 * Namespaced localStorage keys for this product only.
 * Generic keys (e.g. reused from another copied project) collide on the same
 * browser origin and can send the wrong JWT to the API (401 on login).
 */

export const KT_AUTH_TOKEN_KEY = "kt_jwt_v1";
export const KT_AUTH_USER_KEY = "kt_session_user_v1";

const LEGACY_PUBLIC_TOKEN = "cjtokennow";
const LEGACY_PUBLIC_USER = "user";

export function migrateKurdishTalentPublicAuth() {
  try {
    if (typeof localStorage === "undefined") return;
    if (localStorage.getItem(KT_AUTH_TOKEN_KEY)) return;
    const t = localStorage.getItem(LEGACY_PUBLIC_TOKEN);
    if (!t) return;
    localStorage.setItem(KT_AUTH_TOKEN_KEY, t);
    const u = localStorage.getItem(LEGACY_PUBLIC_USER);
    if (u) localStorage.setItem(KT_AUTH_USER_KEY, u);
    localStorage.removeItem(LEGACY_PUBLIC_TOKEN);
    localStorage.removeItem(LEGACY_PUBLIC_USER);
  } catch (e) {
    /* ignore quota / private mode */
  }
}

/** CMS-only JWT; never share with main site session (`KT_AUTH_TOKEN_KEY`). */
export const KT_CMS_TOKEN_KEY = "kurdishtalent_cms_access_jwt_v1";
/** CMS staff session payload (admin/editor from `/cms/login` only). */
export const KT_CMS_USER_KEY = "kurdishtalent_cms_staff_session_v1";

const LEGACY_CMS_TOKEN = "cjtokencms";
const LEGACY_CMS_USER = "cmsuser";
/** Previous CMS keys (same origin as public app — migrate once). */
const PREV_CMS_TOKEN_KEY = "kt_cms_jwt_v1";
const PREV_CMS_USER_KEY = "kut_cms_session_v1";

export function migrateKurdishTalentCmsAuth() {
  try {
    if (typeof localStorage === "undefined") return;
    if (localStorage.getItem(KT_CMS_TOKEN_KEY)) return;
    const t =
      localStorage.getItem(PREV_CMS_TOKEN_KEY) ||
      localStorage.getItem(LEGACY_CMS_TOKEN);
    if (!t) return;
    localStorage.setItem(KT_CMS_TOKEN_KEY, t);
    const u =
      localStorage.getItem(PREV_CMS_USER_KEY) ||
      localStorage.getItem(LEGACY_CMS_USER);
    if (u) localStorage.setItem(KT_CMS_USER_KEY, u);
    localStorage.removeItem(PREV_CMS_TOKEN_KEY);
    localStorage.removeItem(PREV_CMS_USER_KEY);
    localStorage.removeItem(LEGACY_CMS_TOKEN);
    localStorage.removeItem(LEGACY_CMS_USER);
  } catch (e) {
    /* ignore */
  }
}

/** Used by services/http.js (axios-style helper), separate from main app session. */
export const KT_HTTP_USER_KEY = "kurdishtalent_http_user_v1";
const LEGACY_HTTP_USER = "authenticate";

export function migrateKurdishTalentHttpUser() {
  try {
    if (typeof localStorage === "undefined") return;
    if (localStorage.getItem(KT_HTTP_USER_KEY)) return;
    const u = localStorage.getItem(LEGACY_HTTP_USER);
    if (!u) return;
    localStorage.setItem(KT_HTTP_USER_KEY, u);
    localStorage.removeItem(LEGACY_HTTP_USER);
  } catch (e) {
    /* ignore */
  }
}
